module.exports = __webpack_public_path__ + "img/executioners_axe.eb149524.jpg";